//@flow
import React from "react";
import "./nav.scss";
import { Breadcrumbs } from "../breadcrumbs";
import { CTAPrint } from "../cta-print";

export function Nav() {
  return (
    <div className="wishlist-main__nav">
      <Breadcrumbs />
      <div className="wishlist-main__page-actions-group">
        <CTAPrint />
      </div>
    </div>
  );
}
